import React from 'react';
import {isMobile} from 'react-device-detect';
import {Col, Row, Container, Input} from 'reactstrap';
import HeadLineComponent from '../../Block/AbroadBusinessIndividualBlock/HeadlineComponent';
import InputText from '../TextInput/TextInput';
import './ValidationInputsWithRadio.scss';

export default function ValidationInputsWithRadio(props) {
  const isRadio = props?.isRadio == true || props?.isRadio == undefined ? true : false;

  const getTextInputValue = (input) => {
    if (props.subscriberNumberAsValue && input?.id === 1) {
      return props.subscriberNumberAsValue;
    }

    if (props.subscriberNumberAsValue && input?.id === 3) {
      return props.simSerialNumber;
    }

    if (isRadio) {
      const isMatch = props?.formType?.id === input?.id || props?.formType?.id === '';
      return isMatch ? props?.typedNumber?.value : '';
    }

    return props?.getValue(input.id);
  };

  const isTextInputDisabled = (input) => {
    if (props.subscriberNumberAsValue && input?.id === 1 ) {
      return true;
    }

     if (props.simSerialNumber && input?.id === 3) {
      return true;
    }

    if (isRadio) {
      return props?.form.length > 1 && props?.formType.id !== input.id;
    }

    return false;
  };

  const  executeOnChange = (e, input) => {
    const value = e.target.value;

    if (isRadio) {
      props?.setTypedNumber({
        id: props?.formType.id,
        value: value,
      });
    }
    else {
      props?.onChange(input.id, value);
    }
  };

  return (
    <Container fluid className='validate-business-phone'>
      {props?.title && props?.boldTitle && <HeadLineComponent title={props?.title} boldTitle={props?.boldTitle} />}
      <Row className='justify-content-center mt-3'>
        <Col className='d-flex justify-content-center'>
          <div className={`background-container ${isMobile ? 'w-100' : 'w-25'}`}>
            {props?.form.map((input, i) => {
              return (
                <div className='input-with-radio' key={i}>
                  {props?.form.length > 1 && isRadio && (
                    <div className='input-text-container'>
                      <input
                        type='radio'
                        name={input.formType}
                        onClick={() => props?.radioButtonClick(input.id, input.formType, i)}
                        checked={props?.formType.id === input.id}
                        style={{width: '5%'}}
                      />
                      <span>כניסה עם {input.inputName}</span>
                    </div>
                  )}
                  <div className='text-input'>
                    <InputText
                      disabled={isTextInputDisabled(input)}
                      className=''
                      name=''
                      value={getTextInputValue(input)}
                      pattern={input.pattern ? input.pattern : ''}
                      id={i}
                      maxLength={input.maxLength ? input.maxLength : ''}
                      autoComplete='off'
                      placeholder={`${input.inputText ? input.inputText : input.inputName + ' ' + 'השייך לחברה'} `}
                      required='required'
                      onChange={(e) => executeOnChange(e, input)}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </Col>
      </Row>
      {props.isDateTime && props.dateTime()}
      {props?.getButtonModes()}
    </Container>
  );
}
